import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import Detail from './ApprovalDetail';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
import { ThemeContext } from './ApplicationIndex';
import IconButton from '@mui/material/IconButton';
// import { Modal, Row, Col, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent } from '@mui/material';
import { Authentication } from '../../App'
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import moment from 'moment';
import './Css/Grid.css'
import { purple, red, grey } from '@mui/material/colors';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import {
	ColumnDef,
	flexRender,
	getCoreRowModel,
	useReactTable,
    createColumnHelper
} from '@tanstack/react-table'


// Table data as a list of array.

const person = [
    {
      firstName: 'tanner',
      lastName: 'linsley',
      age: 24,
      visits: 100,
      status: 'In Relationship',
      progress: 50,
    },
    {
      firstName: 'tandy',
      lastName: 'miller',
      age: 40,
      visits: 40,
      status: 'Single',
      progress: 80,
    },
    {
      firstName: 'joe',
      lastName: 'dirte',
      age: 45,
      visits: 20,
      status: 'Complicated',
      progress: 10,
    },
  ]


function App() {
    const value= useContext(ThemeContext);
    const [data, setData] = React.useState(() => [...person])
    const [data_column, setDataColumn] = React.useState(() => [...person])
    const [columns, setClumns] = React.useState([])
    const [user_details, setUserDetails] = React.useState([])
    const [users_select, setUsersSelect] = React.useState([])
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
      })
    useEffect(()=>{
        console.log("コンテキスト",value)
        setData(value.table)
        // const column_t = value.column_t;
        setClumns(value.columns_t)
        setDataColumn(value.column);

        setUserDetails(value.user_details);
        setUsersSelect(value.users_select);

        setColumnWidths(value.column)
    },[value])

    const [columnWidths, setColumnWidths] = useState({column1:70, column2:90, column3:90, column4:90, column5:90, column6:90});

    const [modal, setModal] = useState(false);

    const [application_id, setApplicationId] = useState([]);

    const authentication = useContext(Authentication)

    // const token = authentication.getAccessToken();

    const handleOpen = async(e, index, data) => {

        setApplicationId(data[index].application_id)

        setModal(true)

    };

    const _rowClassNameGetter = async(index, data) => {
        // alert(index)
        if(data){
            if(data[index].application_id) {
                // alert(data[index].application_id)
                return "normal"
            }else{
                return ""
            }
        }else{
            return ""
        }

    };
    return (
        // <ThemeContext.Consumer>
        //     {(value) => {


        //         return
                 data.length> 0 && columns && columns.length > 0 ? (<div>
                
                
                {/* <table>
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                <th key={header.id}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id}>
              {row.getVisibleCells().map(cell => (
                <td key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          {table.getFooterGroups().map(footerGroup => (
            <tr key={footerGroup.id}>
              {footerGroup.headers.map(header => (
                <th key={header.id}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.footer,
                        header.getContext()
                      )}
                </th>
              ))}
            </tr>
          ))}
        </tfoot>
      </table>
                 */}
                
                
                
                
                
                
                <Table 
                    className='gridNormalList'
                    rowHeight={34}
                    rowsCount={data.length}
                    width={window.innerWidth - 125}
                    height={window.innerHeight-230}
                    headerHeight={30}
                    onColumnResizeEndCallback={(newColumnWidth, columnKey) => {
                        let columnsset = columnWidths.map(function (value, key) {
                            if (key === columnKey) {
                              value.size = newColumnWidth
                            }
                            return value
                          })
                          setColumnWidths(columnsset)

                    }}
                    isColumnResizing={false}
                    onRowClick={(e, index)=>handleOpen(e, index, data)}

                >
                    {
                        data_column.map(function (value, key) {
                            return <Column width={data_column[key].size} className={"normal"} isResizable={true} columnKey={key} header={<Cell>{data_column[key].name}</Cell>} cell={({ rowIndex, ...props }) => (<Cell {...props}>{data[rowIndex][data_column[key].column]}</Cell>)} />
                        })

                    }
                
                </Table>
                
                <Dialog open={modal} fullWidth={true} maxWidth={"xxl"} onClose={(e) => { setModal(false) }} className="modal-dialog-centered">
                    <DialogTitle>
     
                            <TaskAltIcon style={{fontSize:20, marginRight:5}} /><span>承認状況</span>

                            <IconButton aria-label="close" style={{position:'absolute', right:1, top:1}} onClick={(e) => { setModal(false) }}>
                                <CloseIcon />
                            </IconButton>
                        
                    </DialogTitle>
                    <DialogContent>

                        <Detail application_id={application_id} user_details={user_details} users_select={users_select} />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" style={{marginLeft: 3, backgroundColor:grey['300'], color:"black"}} onClick={(e) => { setModal(false) }}>閉じる</Button>
                    </DialogActions>

                </Dialog>

                

                </div>) : ""

            // }}
        // </ThemeContext.Consumer>
    );

}

export default App;

// // Render your table
// ReactDOM.render(
//     <Table
//         rowHeight={50}
//         rowsCount={rows.length}
//         width={5000}
//         height={5000}
//         headerHeight={50}>
//         <Column
//             header={<Cell>Col 1</Cell>}
//             cell={<Cell>Column 1 static content</Cell>}
//             width={2000}
//         />
//         <Column
//             header={<Cell>Col 2</Cell>}
//             cell={<MyCustomCell mySpecialProp="column2" />}
//             width={1000}
//         />
//         <Column
//             header={<Cell>Col 3</Cell>}
//             cell={({ rowIndex, ...props }) => (
//                 <Cell {...props}>
//                     Data for column 3: {rows[rowIndex]}
//                 </Cell>
//             )}
//             width={2000}
//         />
//     </Table>,
//     document.getElementById('example')
// );